var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":24}},[_c('MapChart',{attrs:{"cdata":_vm.mapData,"chartId":'mapChart',"width":'800px',"height":'900px'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }